export const getPackagesMapper = (data) => {
  const packages = data.packages.list.edges.map(({ node }) => ({
    packageId: node.id_package,
    packageName: node.package_name,
    packageType: node.package_type,
    meta: JSON.parse(node.meta),
  }));
  return [packages, data.packages.list.pageInfo];
};

export const getAssignedAccountsToPackage = (data) => {
  const assignedAccounts = data.packages.by_id.assignment.map(
    ({ id_ipmp }) => id_ipmp,
  );
  const packageName = data.packages.by_id.package_name;
  const packageType = data.packages.by_id.package_type;
  const accounts = data.ipmp_accounts.edges.map(({ node }) => ({
    ...node,
    enabled: Boolean(node.enabled),
    assigned: assignedAccounts.includes(node.id_ipmp),
  }));
  return [{ packageName, packageType, accounts }, data.ipmp_accounts.pageInfo];
};

export const readOtaHmacQueryMapper = (data) => {
  if (!data) return [];
  return data.packages.hmac.map((hmacInfo, index) => ({
    id: index,
    aota_pkg_version: hmacInfo.aota_pkg_version,
    hmac_secret_b64url: hmacInfo.hmac_secret_b64url,
  }));
};

export const hmacInfoMapper = (hmacInfo) => ({
  aota_pkg_version: hmacInfo.aota_pkg_version,
  hmac_secret_b64url: hmacInfo.hmac_secret_b64url,
});
